module.exports = __webpack_public_path__ + "static/img/in.ff45b92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/in.png
// module id = RVpq
// module chunks = 1 3